import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
    
export const exportarExcel = async (datos, nombreArchivo) => {
    const tipoArchivo = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const extension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(datos);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: tipoArchivo });
    
    FileSaver.saveAs(data, nombreArchivo + extension);
}